import React from "react";

export default function StatusBadge({ status }) {
  const styles = {
    PENDING: { background: "#f1c40f", color: "#000" },
    APPROVED: { background: "#2ecc71", color: "#fff" },
    REJECTED: { background: "#e74c3c", color: "#fff" }
  };

  return (
    <span style={{
      padding: "6px 12px",
      borderRadius: "8px",
      fontSize: "12px",
      fontWeight: 600,
      ...styles[status]
    }}>
      {status}
    </span>
  );
}
